import axios from "axios";
import { toast } from "sonner";

// Pakai ketika catch error dari elysia backend
export function elysiaErr(err: any, showToast = true) {
    // 1. Cek jika error berasal dari Axios (Response dari Backend)
    if (axios.isAxiosError(err)) {
        const data = err.response?.data;
        console.error({
            status: err.response?.status,
            statusText: err.response?.statusText,
            data: data, // Ini biasanya berisi detail error dari backend
            message: err.message
        });
        if (typeof data === 'string') {
            toast.error(err.response?.statusText, {
                description: data
            });
        } else if (typeof data?.error === 'string') {
            toast.error(data?.error, {
                description: data?.detail || '',
            });
        } else if (showToast && typeof err.message === 'string')
            toast.error(err.message);

        // Opsional: Tampilkan pesan spesifik ke user via Toast
    }
    // 2. Cek jika error terjadi saat setup request (Network error)
    else if (err.request) {
        console.error("Tidak dapat terhubung ke server", err.request);
    }
    // 3. Error lainnya (Code error/Syntax)
    else if (typeof err.message === 'string') {
        console.error(`Error: ${err.message}`);
    }
}